import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import toast from 'react-hot-toast'

const baseUrl = `${process.env.REACT_APP_BASE_API}Schedule/movement`

export const getData = createAsyncThunk('movement/getData', async params => {
  const response = await axios.post(`${baseUrl}/movementList`, {
      Request: {
        ListMovement: params
      }
    })
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

// ** Create Transfer
export const createTransfer = createAsyncThunk('movements/createTransfer', async (CreateTransfer, { rejectWithValue}) => {
  try {
    const response = await axios.post(`${baseUrl}/createTransfer`, {
      Request: {
        CreateTransfer
      }
    })
    if (response.data.Response.Code === 1) {
      toast.success('Transferencia creada con éxito')
      return response.data.Response
    } else {
      return rejectWithValue(response.data.Response.Description || 'Error al crear la transferencia')
    }
  } catch (error) {
    return rejectWithValue('Error en la conexión al crear la transferencia')
  }
})


export const movementsSlice = createSlice({
  name: 'movements',
  initialState: {
    data: [],
    total: 1,
    params: {},
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getData.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
        toast.error('Error al cargar los movimientos')
      })
      .addCase(createTransfer.pending, () => {
        // No se modifica el loading global
      })
      .addCase(createTransfer.fulfilled, () => {
        // No es necesario hacer nada aquí
      })
      .addCase(createTransfer.rejected, (state, action) => {
        state.error = action.payload
      })
  }
})

export default movementsSlice.reducer
